import { pflegeServicesBaseConfig } from './base'

const config: RawPageConfig[] = [
  {
    ...pflegeServicesBaseConfig,
    headers: {
      'X-Sepac-Environment': 'Services',
    },
    storyblok: {
      ...pflegeServicesBaseConfig.storyblok,
      tokenNuxtRuntimeName: process.env.NUXT_PUBLIC_ENVIRONMENT === 'staging' ? 'pflegeServicesDraftAccessToken' : 'pflegeServicesPublishedAccessToken',
      accessLevel: process.env.NUXT_PUBLIC_ENVIRONMENT === 'staging' ? 'draft' : 'published',
    },
  },
]

export default config
